import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';
import { Dispatch } from 'src/app/classes/dispatch';
import { DispatchTaskGroupSummary } from 'src/app/classes/dispatch-task-group-summary';
import { DispatchTaskStatus } from 'src/app/classes/dispatch-task-status';
import { Events } from 'src/app/classes/events';
import { TaskType } from 'src/app/classes/task-type-enum';
import { DispatchService } from 'src/app/services/dispatch.service';
import { EventsService } from 'src/app/services/events.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  standalone: false,
  selector: 'app-dispatch-task-header',
  templateUrl: './dispatch-task-header.component.html',
  styleUrls: [ './dispatch-task-header.component.scss' ]
})
export class DispatchTaskHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() task: DispatchTaskGroupSummary;

  TaskType = TaskType;
  preferredDriversList: string[] = [];
  timeMathResult: string[];
  flightCustoms: string[] = [];

  subs = new Subscription();

  constructor(
    readonly utilityService: UtilitiesService,
    readonly eventsService: EventsService,
    readonly dispatchService: DispatchService
  ) {}

  ngOnInit(): void {
    this.eventsService.eventData$
      .pipe(skipWhile((eventData: any) => !eventData), take(1))
      .subscribe((eventData: Events) => (this.flightCustoms = eventData.uiParameters.FLIGHT_CUSTOMS));

    this.subs.add();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.task.currentValue) {
      this.timeMathResult = this.timeMath(changes.task.currentValue.plannedTaskCompletionDateTime);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  subToDispatchData(): Subscription {
    return this.dispatchService.getDispatchData().subscribe((dispatchData: Dispatch) => {
      this.preferredDriversList = (dispatchData.preferredDriversList || [])
        .map((driver: string) => driver.toUpperCase());
    });
  }

  getStatusColor(taskGroupStatus: DispatchTaskStatus): string {
    return this.utilityService.getStatusColor(taskGroupStatus);
  }

  hasCustoms(origin: string): boolean {
    return this.flightCustoms.includes(origin);
  }

  timeMath(date: string): string[] {
    return this.utilityService.timeMath(date);
  }
}
